import { render, staticRenderFns } from "./ApmsRegContractSettlementSummaryDetail.vue?vue&type=template&id=66047a12&scoped=true&"
import script from "./ApmsRegContractSettlementSummaryDetail.vue?vue&type=script&lang=js&"
export * from "./ApmsRegContractSettlementSummaryDetail.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66047a12",
  null
  
)

export default component.exports